import { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
// import { createStyles, makeStyles, Theme } from "@mui/material/styles";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import { APIContext } from "../../store/APIStore";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";
import { useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";

export enum apiType {
  SYSADMIN = "sys_admin",
  DEVELOPER = "developer",
}

export interface IProps {
  type: string;
}

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     wrapper: {},
//     topActions: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       marginBottom: "10px",
//     },
//   })
// );

const APIDocsView = ({ type }: IProps) => {
  // const classes = useStyles();
  const api = useContext(APIContext);
  const redirect = useRedirect();

  // permissions
  const canViewApi = useHasPermissions(PERMISSIONS.CAN_VIEW_API);
  const canViewInternalApi = useHasPermissions(
    PERMISSIONS.CAN_VIEW_INTERNAL_API
  );

  // redirect if no permission to access this page
  useEffect(() => {
    if (canViewApi === false && type === apiType.DEVELOPER) {
      redirect(`/${routePaths.ACTIVE_EVENTS}`);
    }

    if (canViewInternalApi === false && type === apiType.SYSADMIN) {
      redirect(`/${routePaths.ACTIVE_EVENTS}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canViewApi, canViewInternalApi]);

  return (
    <Box>
      {/* <Box className={classes.topActions}>
        <Typography component="h3" variant="h3">
          Developers API Documentation
        </Typography>
      </Box> */}

      <Box>
        {/* sys admin api docs */}
        {type === apiType.SYSADMIN && (
          <SwaggerUI url={`${api.swaggerUrl}/v3/api-docs/resources`} />
        )}

        {/* dev api docs */}
        {type === apiType.DEVELOPER && (
          <SwaggerUI url={`${api.swaggerUrl}/v3/api-docs/integration`} />
        )}
      </Box>
    </Box>
  );
};

export default APIDocsView;
